import { render, staticRenderFns } from "./ThemePick.vue?vue&type=template&id=4c15d6f7"
import script from "./ThemePick.vue?vue&type=script&lang=js"
export * from "./ThemePick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports